<template>
  <v-alert class="nitg__alert"
           v-model="alert.show"
           tile
           :type="alert.type"
           mode="out-in"
           dismissible
           transition="slide-x-reverse-transition">
    <span>{{ alert.message }}</span>
  </v-alert>
</template>

<script>
export default {
  name: 'AlertComponent',
  props: {
    alert: null
  },
  created () {
    setTimeout(() => {
      this.$store.dispatch('setAlert', false)
    }, 15000)
  }
}
</script>
